import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Radio, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';
import { fetchData, sendData } from '../../../httpRequests';
import { collection, addDoc, query, where, onSnapshot } from 'firebase/firestore';
import { db, firebase } from '../../../firebase';
const { Search } = Input;
const { Option } = Select;

const form = {

    driver_id: null,
    pharmacy_id: 0,
    driver_idFilter: 0,
    defaultInput: 0

}

export default function ordersAsing() {
    const [idpharmacy, setIdPharmacy] = useState(Number(localStorage.getItem("PHARMACY_LOGGED")))
    const [modalAsignar, setModalAsignar] = useState(false)
    const [formValues, setFormValues] = useState(form)
    const [order, setOrder] = useState([])
    const [AllOrder, setAllOrder] = useState([])
    const [defaultOrder, setDefaultOrder] = useState([])
    const [selectionType, setSelectionType] = useState('checkbox');
    const [ordersId, setOrdersId] = useState([])
    const [fharmacies, setFharmacies] = useState([]);
    const [driver, setDriver] = useState([])
    const [driverFilter, setDriverFilter] = useState([])

    const { driver_id, pharmacy_id, driver_idFilter, defaultInput } = formValues

    useEffect(() => {
        getDrivers()
        getOrdersAll()
        getFharmacies()

    }, [])
    const modalCreateAsinar = () => {
        setModalAsignar(true)
    }
    const handleCancel = () => {
        setModalAsignar(false)
    }


    const getDrivers = () => {
        const url = '/user/getDriverByPharmacy';
        sendData(url, { pharmacy_id: idpharmacy }).then((response) => {
            if (Object.keys(response).length > 0) {
                setDriver(response.driver)

                let dataDriver = [...response.driver]
                dataDriver.unshift({ driver_id: 0, id: 0, first_name: 'All' })
                setDriverFilter(dataDriver)
            }
        })
    }
    const cropDate = (dateStr) => {
        const date = new Date(dateStr);
        return <span>{date.toDateString()}</span>;
    };
    const columns = [
        { title: 'Order #', dataIndex: 'code', key: 'code' },
        {
            title: 'Status',
            render: ({ order_state_id }) => (
                <span>
                    {(order_state_id == 1 && 'Pending') ||
                        (order_state_id == 2 && 'Processing') ||
                        (order_state_id == 3 && 'Ready for pick up by delivery') ||
                        (order_state_id == 4 && 'On the way') ||
                        (order_state_id == 5 && 'Delivered') ||
                        (order_state_id == 6 && 'Rejected') ||
                        (order_state_id == 7 && 'Ready to be picked up by client')}
                </span>
            ),
            key: 'order_state_id'
        },
        {
            title: 'For Pickup',
            render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
        },
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'ascend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
                multiple: 1
            }
        },
        {
            title: 'Time passed',
            render: ({ created_at }) => {
                const date = new Date(created_at);
                const today = new Date();
                let msec = today - date;
                let time = '';

                const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
                msec -= dd * 1000 * 60 * 60 * 24;
                const hh = Math.floor(msec / 1000 / 60 / 60);
                msec -= hh * 1000 * 60 * 60;
                const mm = Math.floor(msec / 1000 / 60);
                msec -= mm * 1000 * 60;

                time = mm + 'min';

                if (hh > 0) {
                    time = hh + 'hr ' + mm + 'min';
                }
                if (dd > 0) {
                    time = dd + 'd ' + hh + 'hr ' + mm + 'min';
                }

                return <span>{time}</span>;
            },
            key: 'created_at',
            defaultSortOrder: 'ascend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
                multiple: 1
            }
        },
        { title: 'Total $', dataIndex: 'total_order', key: 'total_order' },
        { title: 'Pharmacy', dataIndex: 'name' }
    ];
    const columns2 = [
        { title: 'Order #', dataIndex: 'code', key: 'code' },
        {
            title: 'Status',
            render: ({ order_state_id }) => (
                <span>
                    {(order_state_id == 1 && 'Pending') ||
                        (order_state_id == 2 && 'Processing') ||
                        (order_state_id == 3 && 'Ready for pick up') ||
                        (order_state_id == 4 && 'On the way') ||
                        (order_state_id == 5 && 'Delivered') ||
                        (order_state_id == 6 && 'Rejected') ||
                        (order_state_id == 7 && 'Ready to be picked up by client')}
                </span>
            ),
            key: 'order_state_id'
        },
        // {
        //     title: 'For Pickup',
        //     render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
        // },
        {
            title: 'Driver',
            render: ({ driver_name }) => <span>{driver_name}</span>
        },
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'ascend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
                multiple: 1
            }
        },
        {
            title: 'Time passed',
            render: ({ created_at }) => {
                const date = new Date(created_at);
                const today = new Date();
                let msec = today - date;
                let time = '';

                const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
                msec -= dd * 1000 * 60 * 60 * 24;
                const hh = Math.floor(msec / 1000 / 60 / 60);
                msec -= hh * 1000 * 60 * 60;
                const mm = Math.floor(msec / 1000 / 60);
                msec -= mm * 1000 * 60;

                time = mm + 'min';

                if (hh > 0) {
                    time = hh + 'hr ' + mm + 'min';
                }
                if (dd > 0) {
                    time = dd + 'd ' + hh + 'hr ' + mm + 'min';
                }

                return <span>{time}</span>;
            },
            key: 'created_at',
            defaultSortOrder: 'ascend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) < new Date(b.created_at),
                multiple: 1
            }
        },
        // { title: 'Total $', dataIndex: 'total_order', key: 'total_order' },
        { title: 'Pharmacy', dataIndex: 'name' }
    ];

    const handleFilterDriver = (e) => {
        setFormValues({
            ...formValues,
            driver_id: e,

        })
        console.log("busvar ordernes de la farmacias que el tenga asignadad pero que ya no esten asignada", e)

        const url = `/driver/getOrderToAsing/${e}`;
        fetchData(url,).then((response) => {
            if (Object.keys(response).length > 0) {
                setOrder(response.order)
            }
            console.log(response)
        })

    }
    const rowSelection = {

        onChange: (selectedRowKeys, selectedRows) => {
            let ordesId = []
            // setFormValues({
            //     ...formValues,
            //     adsAdmin: selectedRows
            // })

            selectedRows.map(e => {
                ordesId.push(e.id)
            })
            setOrdersId(ordesId)
            // console.log(ordersId)
        },

    };

    const saveOrdersIdUpdate = async () => {
        let url = `/driver/updateOrderToAsing/${driver_id}`
        sendData(url, { ordersId: ordersId }).then(async (response) => {
            if (Object.keys(response).length > 0) {

                setModalAsignar(false)
                const addOrderfirebase = await firebase.firestore().collection('ordersAdminDriver')
                addOrderfirebase.add({
                    order_status: 3,
                    admin: true,
                    driver_id: driver_id
 
                })
                //         const addOrderfirebase2 = await firebase.firestore().collection('orders')
                //         addOrderfirebase2.add({
                //             farmacy_id: pharmacy_id,
                //             order_status: 3,
                //             driver_id:driver_id

                //         })
            }
        })
        // console.log(ordersId, url)




    }

    const getOrdersAll = async () => {
        let url = '/orders/getOrders'
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                console.log(response.orders)
                setAllOrder(response.orders)
                setDefaultOrder(response.orders)
            }
        })
    }

    const getFharmacies = () => {
        const url = '/pharmacies/getPharmacies';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                // const farmacies = response['pharmacy'];

                let dataPharmacies = [...response.pharmacy]
                dataPharmacies.unshift({ id_pharmacy: 0, id: 0, name: 'All' })
                setFharmacies(dataPharmacies)

            }
        })
    }

    const handleFilterPhamaciesSearch = (value) => {
        setFormValues({
            ...formValues,
            pharmacy_id: value,
            driver_idFilter: 0,
            defaultInput: 0
        })

        const filter = defaultOrder.filter((e) => {
            // console.log(e)
            return e.pharmacy_id == value
        })

        if (value == 0) {
            setAllOrder(defaultOrder)
        } else {
            setAllOrder(filter)
        }



    }

    const handleDriverSearch = (value) => {
        setFormValues({
            ...formValues,
            driver_idFilter: value,
            pharmacy_id: 0,
            defaultInput: 0

        })

        // console.log(value)
        const filter = defaultOrder.filter((e) => {

            return e.driver_id == value
        })

        if (value == 0) {

            setAllOrder(defaultOrder)
        } else {

            setAllOrder(filter)
        }
    }

    const handleChangeStatus = (value) => {
        console.log(value)

        setFormValues({
            ...formValues,
            driver_idFilter: 0,
            pharmacy_id: 0,
            defaultInput: value

        })

        const filter = defaultOrder.filter((e) => {

            return e.order_state_id == Number(value)
        })


        if (Number(value) == 0) {

            setAllOrder(defaultOrder)
        } else {

            setAllOrder(filter)
        }

    }


    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={5}>
                    <Search
                        size='large'
                        placeholder='Search name'
                    // onChange={onSearch}
                    />
                </Col>
                <Col span={5} style={{ marginBottom: '20px' }}>

                    <Select
                        style={{ width: '100%' }}
                        size='large' name="pharmacy_id"
                        placeholder=' Select Pharmacy'

                        value={pharmacy_id}
                        onChange={handleFilterPhamaciesSearch}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {fharmacies.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={5} style={{ marginBottom: '20px' }}>

                    <Select
                        style={{ width: '100%' }}
                        size='large' name="driver_idFilter"
                        placeholder='Select Driver'
                        value={driver_idFilter}
                        onChange={handleDriverSearch}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {driverFilter.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.first_name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={5} style={{ marginBottom: '20px' }}>

                    <Select
                        placeholder='Select status'
                        defaultValue={defaultInput}
                        size='large'
                        onChange={handleChangeStatus}
                        style={{ width: '100%' }}
                    >
                        <Option value={0}>All</Option>
                        <Option value='1'>Pending</Option>
                        <Option value='2'>Proccesing</Option>
                        <Option value='3'>Ready for pick up by delivery</Option>
                        <Option value='4'>On the way</Option>
                        <Option value='5'>Delivered</Option>
                        <Option value='6'>Rejected</Option>
                        <Option value='7'>Ready to be picked up by client</Option>
                    </Select>
                </Col>



                <Col span={4}>
                    <Button
                        onClick={modalCreateAsinar}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        <PlusOutlined />
                        Assign orders
                    </Button>
                </Col>
            </Row>
            <Modal
                title="Orders"
                visible={modalAsignar}
                onCancel={handleCancel}
                width={1000}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>
                    <Col span={24} className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Select Driver</label>
                        <Select
                            style={{ width: '100%' }}
                            size='large' name="pharmacy_id"
                            placeholder='Select Driver'
                            value={driver_id}
                            onChange={handleFilterDriver}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {driver.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.first_name}
                                </Select.Option>
                            ))
                            }
                        </Select>
                    </Col>


                    <Col span={24} className='formMarginInput' >
                        <Radio.Group
                            onChange={({ target: { value } }) => {
                                setSelectionType(value);
                            }}
                            value={selectionType}
                        >


                        </Radio.Group>
                        <Table rowSelection={{
                            type: selectionType,
                            ...rowSelection,
                        }} columns={columns} dataSource={order} rowKey={(item) => item.id}
                        />
                    </Col>

                    <Col span={24}>
                        <Button

                            onClick={saveOrdersIdUpdate}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                        // disabled={pharmacies_id == null || adsAdmin.length < 1}
                        >
                            {/* <PlusOutlined /> */}
                            Save
                        </Button>
                    </Col>
                </Row>

            </Modal>

            <Table columns={columns2} dataSource={AllOrder} rowKey={(item) => item.id}
            />

        </div>
    )

}